import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

/**
 * Компонент для ввода габаритов товара
 * @param {Object} measurements - объект с габаритами товара
 * @param {Function} onChange - функция для обновления габаритов
 */
export const MeasurementsForm = ({ measurements, onChange }) => {
  // Устанавливаем значения по умолчанию, если measurements не определен
  const values = measurements || {
    WeightInGramms: 0,
    HeightInMillimeters: 0,
    LengthInMillimeters: 0,
    WidthInMillimeters: 0
  };

  // Обработчик изменения значения поля
  const handleChange = (field, value) => {
    // Преобразуем значение в число
    const numericValue = value === '' ? 0 : Number(value);
    
    // Проверяем, что значение является числом и не отрицательным
    if (!isNaN(numericValue) && numericValue >= 0) {
      onChange({
        ...values,
        [field]: numericValue
      });
    }
  };

  return (
    <div className="mb-4">
      <h5 className="mb-3">Габариты товара</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Вес (в граммах)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={values.WeightInGramms}
              onChange={(e) => handleChange('WeightInGramms', e.target.value)}
              placeholder="Введите вес в граммах"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Высота (в миллиметрах)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={values.HeightInMillimeters}
              onChange={(e) => handleChange('HeightInMillimeters', e.target.value)}
              placeholder="Введите высоту в миллиметрах"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Длина (в миллиметрах)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={values.LengthInMillimeters}
              onChange={(e) => handleChange('LengthInMillimeters', e.target.value)}
              placeholder="Введите длину в миллиметрах"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Ширина (в миллиметрах)</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={values.WidthInMillimeters}
              onChange={(e) => handleChange('WidthInMillimeters', e.target.value)}
              placeholder="Введите ширину в миллиметрах"
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default MeasurementsForm;
